<template>
  <div class="TopicDirectory">
    <Popup
      :value="value"
      position="bottom"
      :overlay="true"
      @click-overlay="$emit('input', false)"
    >
      <div class="directory">
        <div class="directory-top">
          <div class="name">跳转到</div>
          <div style="padding: 6px" @click="$emit('input', false)">
            <img src="../img/close.png" alt="" />
          </div>
        </div>
        <div class="directory_content">
          <div class="topic-list">
            <TopicBlock
              @click.native="$emit('jumpTopic', i)"
              :mark="displayMark(topic)"
              v-for="(topic, i) in T"
              :key="topic.questionId"
              :index="topic.index"
            />
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import { Popup } from "vant";
import TopicBlock from "@/components/topic/topicBlock/TopicBlock.vue";

export default {
  name: "TopicDirectory",
  props: {
    T: {
      //所有题目
      type: Array,
      default: function() {
        return [];
      }
    },
    markType: {
      type: Number,
      default: 1 //灰色（未做），正确（绿勾），错误（红勾）,黄色（已做）的显示
      //1只标记已做未做。2只标记正确错误
    },
    value: Boolean
  },

  data: function() {
    return {};
  },
  methods: {
    return0Or3Func(t) {
      if (t.type === 1 || t.type === 2) {
        if (t.userAnswer.length > 0) {
          return 3;
        } else {
          return 0;
        }
      } else {
        for (let i = 0; i < t.sonQuestion.length; i++) {
          //需要修改
          let r = t.sonQuestion[i];
          if (r.userAnswer.length === 0) {
            //A3A4题里只要有一道小题未答，则该题视为未答
            return 0;
          }
        }
        return 3;
      }
    },
    return1Or2Func(t) {
      if (t.type === 1 || t.type === 2) {
        if (1 === t.answerType) return 1;
        if (2 === t.answerType) return 2;
        if (3 === t.answerType) return 2;
      } else {
        for (let i = 0; i < t.sonQuestion.length; i++) {
          let r = t.sonQuestion[i];
          if (2 === r.answerType) return 2; //只要其中一个错误就标记为错题
          if (3 === r.answerType) return 2; //只要其中一个未答就标记为错题
        }
        return 1; //正确
      }
    },
    displayMark(t) {
      // 做题的标记
      if (this.markType === 1) {
        //标记已做未做
        return this.return0Or3Func(t);
      }
      if (this.markType === 2) {
        //标记正确错误
        return this.return1Or2Func(t);
      }
    }
  },
  components: { Popup, TopicBlock }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.TopicDirectory {
  .van-popup {
    height: 100%;
    overflow-y: hidden;
  }
  .directory {
    /*height: calc(100vh - 44px);*/
    height: 100%;
    padding: 0 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    width: 100%;
    .directory-top {
      display: flex;
      width: 100%;
      height: 60px;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;

      img {
        width: 12px;
        height: 12px;
      }

      .name {
        font-size: 15px;
        color: #222;
      }
    }
    .directory_content {
      flex: 1;
      overflow-y: auto;
    }
    .topic-list {
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;

      > div {
        margin-bottom: 20px;
        margin-right: 4%;
        &:nth-child(4n + 4) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
